import PropTypes from 'prop-types';

export const APPLE_AUTHENTICATION_DATA_PROPTYPES = PropTypes.shape({
    isPrivateEmail: PropTypes.bool,
    sourceProvider: PropTypes.string,
    expirationTimestamp: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    email: PropTypes.string,
    accessToken: PropTypes.string,
});
